import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'features/auth/slice';

import useDiscountTimer from 'lib/hooks/useDiscountTimer';

import { Heading } from '@frontendmentorio/design-system-v2';

export default function UserDiscount() {
  const currentUser = useSelector(selectCurrentUser);
  const { days, hours, mins, secs } = useDiscountTimer();

  if (!currentUser?.discount) return null;

  return (
    <div className="bg-cyan-500 flex flex-col gap-6 items-center px-6 py-8 rounded-xl text-white w-full desktop:flex-row">
      <div className="flex flex-col gap-4 max-w-prose text-center desktop:text-start">
        <Heading level="2" tagName="h3">
          Time-limited discount
        </Heading>

        <p>
          You've unlocked a time-limited offer on a yearly subscription! A{' '}
          {currentUser.discount.amount * 100}% discount will automatically be
          applied at checkout 🙂
        </p>
      </div>

      <div
        className="grid grid-cols-2 gap-4 text-center mobile:flex"
        role="timer"
      >
        <div className="bg-cyan-600 flex flex-col gap-2 leading-none p-3 rounded-lg w-[5.5rem]">
          <span className="font-bold font-secondary text-2xl">{days}</span>
          <span className="font-semibold">Days</span>
        </div>

        <div className="bg-cyan-600 flex flex-col gap-2 leading-none p-3 rounded-lg w-[5.5rem]">
          <span className="font-bold font-secondary text-2xl">{hours}</span>
          <span className="font-semibold">Hours</span>
        </div>

        <div className="bg-cyan-600 flex flex-col gap-2 leading-none p-3 rounded-lg w-[5.5rem]">
          <span className="font-bold font-secondary text-2xl">{mins}</span>
          <span className="font-semibold">Mins</span>
        </div>

        <div className="bg-cyan-600 flex flex-col gap-2 leading-none p-3 rounded-lg w-[5.5rem]">
          <span className="font-bold font-secondary text-2xl">{secs}</span>
          <span className="font-semibold">Secs</span>
        </div>
      </div>
    </div>
  );
}
